<form [formGroup]="userTypeAndAcademicRegistrationForm" (yatSubmit)="submitForm($event)">
  <div class="row mbottom-12">
    <div class="col-12">
      <h2>You are a …</h2>
    </div>
  </div>
  <div class="mb-2 academic-type-container">
    <div>
      <yat-button-with-embedded-tooltip
        [active]="userTypeAndAcademicRegistrationForm.controls.userType.value === 'STUDENT'"
        tooltipClass="tooltip-xl"
        tooltipContent="Single user license for academic purposes. No commercial usage allowed (not-for-profit). Requires registration and confirmation."
        (selectButton)="selectUserType('STUDENT')">
        <yat-icon id="9d18c8cc-a9b1-4974-986f-0d0d2c045168" name="student-duo" class="user-type-img"></yat-icon>
        <span>Student</span>
      </yat-button-with-embedded-tooltip>
    </div>
    <div>
      <yat-button-with-embedded-tooltip
        [active]="userTypeAndAcademicRegistrationForm.controls.userType.value === 'TEACHER'"
        tooltipClass="tooltip-xl"
        tooltipContent="Single or multi-user license for academic purposes (e.g. teaching, research and development). No commercial usage (e.g. customer projects) allowed (not-for-profit). Requires registration and confirmation. Allows issuing floating sub-licenses to your class (students) without further registration."
        (selectButton)="selectUserType('TEACHER')">
        <yat-icon id="80f78ad6-ee5e-4393-afee-01a95afaee32" name="teacher-duo" class="user-type-img"></yat-icon>
        <span>Teacher</span>
      </yat-button-with-embedded-tooltip>
    </div>
    <div>
      <yat-button-with-embedded-tooltip
        [active]="userTypeAndAcademicRegistrationForm.controls.userType.value === 'ORGANIZATION'"
        tooltipClass="tooltip-xl"
        tooltipContent="License pool with multi-user access for academic purposes (e.g. teaching, r&d). Available for academic, non-profit institutions. No commercial usage allowed (not-for-profit). Requires registration of the organization (license pool owner). Allows issuing floating sub-licenses without further user registration."
        (selectButton)="selectUserType('ORGANIZATION')">
        <yat-icon id="5c47c4dc-670c-47b4-b5d6-f26efd85a6e4" name="organization-duo" class="user-type-img"></yat-icon>
        <span>Organization</span>
      </yat-button-with-embedded-tooltip>
    </div>
  </div>

  <ng-container formGroupName="academicRegistration">
    <div class="row">
      <div class="col-12 mt-3 mbottom-12">
        <h2>Enter academic account information</h2>
      </div>
    </div>
    <div class="row mt-1">
      <div class="col-6 pr-2">
        <div class="form-group">
          <label for="first-name">First name</label>
          <input type="text" class="form-control" id="first-name" formControlName="firstName" maxlength="50" yatAutoFocus yatInput />
          <div class="invalid-feedback" [ngSwitch]="academicRegistrationForm.controls.firstName.errors | classifyValidationError">
            <span *ngSwitchCase="'required'">Wait. You're not Hiro…</span>
          </div>
        </div>
      </div>
      <div class="col-6 pl-2">
        <div class="form-group">
          <label for="last-name">Last name</label>
          <input type="text" class="form-control" id="last-name" formControlName="lastName" maxlength="50" yatInput />
          <div class="invalid-feedback" [ngSwitch]="academicRegistrationForm.controls.lastName.errors | classifyValidationError">
            <span *ngSwitchCase="'required'">Your last name, please?</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="email">Academic email address </label>
          <input type="email" class="form-control" id="email" formControlName="email" maxlength="254" yatInput />
          <yat-tooltip-info-icon id="39e61a7c-bbf6-4339-8273-0e102b85a487"
            tooltipClass="tooltip-xl"
            tooltipContent="For verification, we need an email address of yours that is associated with your university or academic institution.">
          </yat-tooltip-info-icon>
          <div class="invalid-feedback" [ngSwitch]="academicRegistrationForm.controls.email.errors | classifyValidationError">
            <span *ngSwitchCase="'required'">Looks like something's missing here.</span>
            <span *ngSwitchCase="'email'">This email address doesn't seem quite right…</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="organization-name">University or other academic organization</label>
          <input type="text" class="form-control" id="organization-name" formControlName="organizationName" maxlength="50" yatInput />
          <div class="invalid-feedback" [ngSwitch]="academicRegistrationForm.controls.organizationName.errors | classifyValidationError">
            <span *ngSwitchCase="'required'"
              >No idea? Choose one
              <a
                yatExternalLink="https://www.timeshighereducation.com/student/best-universities/best-universities-computer-science-degrees"
                class="c-red underline"
                >here</a
              >!</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-12 mb-0">
        <div class="form-group">
          <label for="organization-web">Website of your academic organization</label>
          <input type="text" class="form-control" id="organization-web" formControlName="organizationWeb" maxlength="2048" yatInput />
          <div class="invalid-feedback" [ngSwitch]="academicRegistrationForm.controls.organizationWeb.errors | classifyValidationError">
            <span *ngSwitchCase="'required'">Need help? Try <a yatExternalLink="https://www.google.com" class="c-red underline">Google</a>!</span>
            <span *ngSwitchCase="'looseUrl'">This doesn't seem quite right...</span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <div class="row">
    <div class="col-12 mb-0">
      <div class="form-group mb-0">
        <button yat-button type="submit" class="btn btn-large primary w-100">Continue</button>
      </div>
    </div>
  </div>
</form>
